module.exports = __webpack_public_path__ + "static/assets/3ea22ba000a74062474ac71ed11ae36f.png";